import IBlock1 from "./IBlock1";
import PlatformUsedType from "@/module/main/dto/financing-v3/PlatformUsedTypeEnum";
import YesNo from "@/app/service/YesNoEnum";

export default class Block1 implements IBlock1
{
    public identificationNumber?: string;
    public identificationNumberRaw?: string;
    public phone?: string;
    public email?: string;
    public firstName?: string;
    public lastName?: string;
    public platformUsed?: PlatformUsedType;
    public consentFinancialDispo?: YesNo;
    public walletUuid?: string;

    constructor(props: IBlock1)
    {
        this.identificationNumber = props.identificationNumber;
        this.identificationNumberRaw = props.identificationNumberRaw;
        this.phone = props.phone;
        this.email = props.email;
        this.firstName = props.firstName;
        this.lastName = props.lastName;
        this.platformUsed = props.platformUsed;
        this.consentFinancialDispo = props.consentFinancialDispo;
        this.walletUuid = props.walletUuid;
    }
}
